import { render, staticRenderFns } from "./NotificationsTable.vue?vue&type=template&id=21024a25&scoped=true"
import script from "./NotificationsTable.vue?vue&type=script&lang=js"
export * from "./NotificationsTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationsTable.vue?vue&type=style&index=0&id=21024a25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21024a25",
  null
  
)

/* custom blocks */
import block0 from "./NotificationsTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports